module.exports = __webpack_public_path__ + "static/media/657EchoStNW_2018-06-25_188.c5fbe6f2.jpg";